import * as React from 'react';



export default class CasheLogo extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (


            <svg className="ccActive" xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
                <path d="M13.786 31.2777C1.95627 26.1818 2.41126 14.4052 4.11748 9.15381C2.12689 11.5994 -2.36614 30.8796 13.786 34.9177C26.7078 38.1481 33.3127 29.7801 35 25.1922C28.5391 34.0191 18.1653 32.9271 13.786 31.2777Z" fill="#6AC6B9" />
                <path d="M7.2065 15.3145C7.62658 4.21402 16.2708 1.24468 20.8383 1.19157C17.3121 0.167841 3.32118 3.01153 4.34491 15.4669C5.16389 25.4312 12.9897 28.5289 16.8003 28.8323C14.6213 28.4607 10.1487 26.2048 7.94438 20.1821C7.37637 18.6302 7.144 16.9659 7.2065 15.3145Z" fill="#54B6E7" />
                <path d="M19.7579 5.969C9.2476 9.88192 9.80496 19.3533 11.3974 23.5999C6.39255 17.1163 8.1556 5.45715 18.9616 2.67033C27.6065 0.440875 32.9905 6.93586 34.602 10.462C32.3839 7.39085 26.8671 3.92154 19.7579 5.969Z" fill="#5A65AE" />
            </svg>


        )
    }
}
